import { Injectable } from "@angular/core";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import ModuleDataGroupItem from "src/shared/models/module-data-group-item";
import MetricData from '../../../AngularJS/Models/metric-data';
import { CVApiService } from "../services/cv-api.service";
import { ObjectivesDetailsComponent } from "./objectives-details.component";
import { ObjectiveDetailsModalInputObj } from "./objectives-details.model";

@Injectable({
    providedIn: "root",
})
export class ObjectivesDetailsService {

    public metric: MetricData;

    constructor(
        private cvApiService: CVApiService,
        private modalService: NgbModal,
    ) {}

    public openObjectivesDetailsModal(
        metric: MetricData,
        groupInfo: ModuleDataGroupItem,
        metricName: string,
        isKpiWidget: boolean = false,
    ): NgbModalRef {

        this.metric = metric;
        const modalRef = this.modalService.open(ObjectivesDetailsComponent, {
            size: 'medium',
            backdrop: "static",
            keyboard: false,
            backdropClass: 'metricSelectorModalBackdrop',//Gray background-color to the modal backdrop
        });
        modalRef.componentInstance.metricData = this.metric;
        modalRef.componentInstance.isKpiWidget = isKpiWidget;
        modalRef.componentInstance.groupInfo = groupInfo;
        modalRef.componentInstance.metricName = metricName;
        return modalRef;

    }

    public async getObjectivesDetailsData(
        isKpiWidget: boolean,
        groupInfo: ModuleDataGroupItem = null,
    ): Promise<any> {
        try {
            const url = `/api/v2/objectives/objectivesDetails/`;
            const requestData: ObjectiveDetailsModalInputObj = {
                isKpiWidget,
                MetricDataValues: this.metric,
            };
            if (groupInfo) {
                requestData.GroupChar = groupInfo.groupType;
                requestData.GroupLevel = groupInfo.groupLevel;
            }
            const response = await this.cvApiService.post<ObjectiveDetailsModalInputObj>(url, requestData);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (error) {
            console.error("Failed getting data for Objectives Details", error);
        }
    }

}
